import { useEffect } from "react";

export const usePageTitle = (pageName: string) => {
    useEffect(() => {
        if (pageName) {
            document.title = ['Medicare.gov', pageName].join(' - ');
        }

        return () => {
            // make sure title is reset when leaving page
            document.title = 'Medicare.gov';
        }
    }, [pageName]);
};